module.exports = __webpack_public_path__ + "img/luntanA_15.b1fb7be5.jpg";